import React, { FC, useCallback, useEffect, useState } from 'react';
import { RangePickerProps } from 'antd/lib/date-picker';
import dayjs, { Dayjs } from 'dayjs';

import { useQuery } from 'hooks';

import { Wrapper, Label, ReqLabel } from '../styled';
import { RangePicker } from './styled';

const DATE_FORMAT = 'DD-MM-YYYY';

export const RangeDatePickerFilter: FC<Props & RangePickerProps> = ({
  label,
  rangeDateName,
  formatDate,
  required,
  ...props
}) => {
  const [dateValue, setDateValue] = useState<[Dayjs, Dayjs]>();

  const { query, replaceQuery } = useQuery();

  useEffect(() => {
    const { dateFrom, dateTo } = query;

    const customFrom = rangeDateName ? query[rangeDateName?.[0]] : '';
    const customTo = rangeDateName ? query[rangeDateName?.[1]] : '';

    const from =
      customFrom || dateFrom
        ? dayjs((customFrom || dateFrom) as string, formatDate || DATE_FORMAT)
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (undefined as any);
    const to =
      customTo || dateTo
        ? dayjs((customTo || dateTo) as string, formatDate || DATE_FORMAT)
        : // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (undefined as any);

    setDateValue([from, to]); // TODO: eslint fix
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, rangeDateName]);

  const onChange = useCallback(
    (dates: [Dayjs, Dayjs], dateStrings: [string, string]) => {
      const [dateFrom, dateTo] = dateStrings;
      const { page } = query;

      setDateValue(dates);

      replaceQuery({
        [rangeDateName?.[0] || 'dateFrom']: dateFrom || undefined,
        [rangeDateName?.[1] || 'dateTo']: dateTo || undefined,
        page: page ? 1 : undefined,
      });
    },
    [query, rangeDateName, replaceQuery],
  );

  return (
    <Wrapper>
      <Label>
        {label} {required && <ReqLabel>*</ReqLabel>}
      </Label>

      <RangePicker
        value={dateValue}
        format={formatDate || DATE_FORMAT}
        separator='—'
        size='small'
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={onChange as any}
        {...props}
      />
    </Wrapper>
  );
};

type Props = {
  label: string;
  rangeDateName?: [string, string];
  formatDate?: string;
};
